import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem,
} from "@/components/ui/dropdown-menu";
import { Languages, Check } from "lucide-react";

const LANGS = [
  { v: "fr", label: "Français", flag: "🇫🇷" },
  { v: "en", label: "English", flag: "🇬🇧" },
  { v: "tr", label: "Türkçe", flag: "🇹🇷" },
];

export default function LanguageToggle() {
  const { i18n } = useTranslation();
  const current = LANGS.find((l) => l.v === (i18n.language || "fr").slice(0, 2)) || LANGS[0];
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="sm" className="h-9 gap-1.5 px-2.5" data-testid="language-toggle">
          <Languages className="h-3.5 w-3.5" />
          <span className="text-xs font-medium uppercase">{current.v}</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-40">
        {LANGS.map((l) => (
          <DropdownMenuItem
            key={l.v}
            onClick={() => i18n.changeLanguage(l.v)}
            data-testid={`lang-${l.v}`}
            className="gap-2"
          >
            <span>{l.flag}</span>
            <span className="flex-1">{l.label}</span>
            {current.v === l.v && <Check className="h-3.5 w-3.5 text-primary" />}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
